export const OltSkeletonCard = () => (
    <div
      className="rounded-2xl p-4 animate-pulse"
      style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-slate-700/50 flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-slate-700/50 rounded-md w-32" />
          <div className="h-3 bg-slate-700/30 rounded-md w-24" />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-3 pt-3" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-10 bg-slate-700/25 rounded-lg" />
        ))}
      </div>
    </div>
  );
